// This cookie should be the same as in creator-hub: https://github.rbx.com/Roblox/creator-hub/blob/4505a9b5cb41e8da3914b3a9c28bcb73f1c35e6c/apps/creator-hub/modules/creator-settings/container/preferences/localizationCookieConstants.ts#L3
const LOCALE_MAX_AGE = 1707109200;

const DOCS_LOCALE_COOKIE = {
  Name: 'roblox-docs-locale',
  Options: {
    // accessible on all pages
    path: '/',
    // expires at max num days from now (400 days)
    'max-age': LOCALE_MAX_AGE,
  },
};

export default DOCS_LOCALE_COOKIE;
